import { RepairShop } from "../../model/RepairShop";
import { axiosUtils } from "../../network/axiosUtils";
import httpRequest from "../../network/httpRequest";
import { HttpResponse } from "../../network/types";

const url = "/repair-shop-master";

/**
 * 마스터 계정 매장 변환 처리 (token)
 * @param id
 * @returns
 */
export const getMasterRepairshopList = async (): Promise<RepairShop[]> => {
  const response: HttpResponse = await httpRequest({
    method: axiosUtils.GET,
    url: `${url}`,
    queryParams: { page: 1, pageSize: 1000 },
  });

  return response?.data.rows;
};
